import { takeLatest, put, call } from 'redux-saga/effects';

import * as services from './services';
import Creators, { MonthlyScoreReportTypes as constants } from './reducer';

const actions = {
  getMonthlyScoreReportActions: {
    request: Creators.getMonthlyScoreReportRequest,
    success: Creators.getMonthlyScoreReportSuccess,
  },
};

const eventsOptions = {
  [constants.GET_MONTHLY_SCORE_REPORT_REQUEST]: {
    api: services.getMonthlyScoreReport,
    actions: actions.getMonthlyScoreReportActions,
  },
};

function* apiGenerator(action) {
  const provider = eventsOptions[action.type];
  try {
    const params = action.payload;
    const response = yield call(provider.api, params);

    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data));
    } else {
      yield put(Creators.monthlyScoreReportFetchingReset());
      // yield put(ErrorsActions.errorSave(response.data ))
    }
  } catch (errors) {
    yield put(Creators.monthlyScoreReportFetchingReset());
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_MONTHLY_SCORE_REPORT_REQUEST, apiGenerator);
}
